import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kategori-skeleton',
  templateUrl: './kategori-skeleton.component.html',
  styleUrls: ['./kategori-skeleton.component.scss'],
})
export class KategoriSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
